/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { EcsperClient } from '@ecsper/api-client';
import type { ReactElement } from 'react';

import { getEnabledPanels, panelRegistry } from './panelRegistry.js';
import type { PanelRegistration } from './types.js';

export interface SidebarPanelsProps {
  readonly reportId: string;
  readonly matterId: string;
  readonly apiClient: EcsperClient;
  /** Optional override for tests. */
  readonly registry?: readonly PanelRegistration[];
}

/** Renders the declarative AI panel stack below version history. */
export function SidebarPanels({
  reportId,
  matterId,
  apiClient,
  registry = panelRegistry,
}: SidebarPanelsProps): ReactElement {
  const panels = getEnabledPanels(registry);

  return (
    <div className="ecs-sidebar-panels">
      {panels.map((panel) => {
        const PanelComponent = panel.component;
        return (
          <PanelComponent
            key={panel.id}
            reportId={reportId}
            matterId={matterId}
            apiClient={apiClient}
          />
        );
      })}
    </div>
  );
}
